<div class="country-coverage">

  <!-- Apply to all countries by default -->
  <div class="toggle-row">
    <div>
      <div class="toggle-row-label">Apply to all countries by default</div>
      <div class="toggle-row-sub">
        {{ allByDefault ? 'Alert covers every country unless you exclude specific ones below'
                        : 'Alert covers only the countries and groups you include below' }}
      </div>
    </div>
    <div class="cc-toggle" [class.on]="allByDefault" (click)="toggleDefault()"><div class="cc-toggle-knob"></div></div>
  </div>

  <!-- Coverage summary -->
  <div class="coverage-bar">
    <div class="cov-pill inc" [class.clickable]="activeTab=='countries'" [class.active-filter]="activeTab=='countries' && activeFilter=='inc'" (click)="toggleFilter('inc')">
      <div class="cov-label">Included</div>
      <div class="cov-value">{{ includedCount }} <span class="cov-unit">countries</span></div>
    </div>
    <div class="cov-pill exc" [class.clickable]="activeTab=='countries'" [class.active-filter]="activeTab=='countries' && activeFilter=='exc'" (click)="toggleFilter('exc')">
      <div class="cov-label">Excluded</div>
      <div class="cov-value">{{ excludedCount }} <span class="cov-unit">countries</span></div>
    </div>
    <div class="cov-pill eff" [class.clickable]="activeTab=='countries'" [class.active-filter]="activeTab=='countries' && activeFilter=='eff'" (click)="toggleFilter('eff')">
      <div class="cov-label">Effective Coverage</div>
      <div class="cov-value">{{ effectiveCount }} <span class="cov-unit">countries</span></div>
    </div>
  </div>

  <!-- Tabs + search -->
  <div class="grid-controls">
    <div class="tab-bar">
      <button type="button" class="tab-btn" [class.active]="activeTab=='countries'" (click)="switchTab('countries')">Countries</button>
      <button type="button" class="tab-btn" [class.active]="activeTab=='groups'" (click)="switchTab('groups')">
        Country Groups <span class="tab-count">{{ groups.length }}</span>
      </button>
    </div>
    @if (activeTab=='countries' && activeFilter != null) {
      <div class="filter-chip">
        <span>Filtered: {{ filterLabel }}</span>
        <button type="button" class="filter-chip-x" (click)="clearFilter()" aria-label="Remove filter">&times;</button>
      </div>
    }
    <input type="text" class="grid-search form-control" [(ngModel)]="query" placeholder="Search..." />
  </div>

  <!-- COUNTRIES -->
  @if (activeTab == 'countries') {
    <div class="grid-list">
      @for (c of filteredCountries; track c.countryId) {
        <div class="grid-row" [class.row-inc]="c.included && groupCoverage.get(c.countryId) !== 'exc'" [class.row-exc]="c.excluded">
          <div class="row-main">
            <div class="row-name">{{ c.countryName || c.alias }}</div>
            <div class="row-meta">{{ c.alpha2Code }}</div>
          </div>
          <div class="grp-cell">
            @if (groupCoverage.get(c.countryId) === 'exc') {
              <span class="grp-pill exc">Excluded via Group</span>
            } @else if (groupCoverage.get(c.countryId) === 'inc') {
              <span class="grp-pill inc" [class.muted]="c.excluded">Included via Group</span>
            } @else if (allByDefault) {
              <span class="grp-pill def" [class.muted]="c.excluded">Included By Default</span>
            }
          </div>
          <div class="seg">
            <button type="button" class="seg-btn" [class.on-inc]="c.included" [class.struck]="c.included && groupCoverage.get(c.countryId) === 'exc'" [disabled]="(!!groupCoverage.get(c.countryId) || allByDefault) && !c.included" (click)="setCountry(c, 'inc')">Include</button>
            <button type="button" class="seg-btn" [class.on-exc]="c.excluded" [disabled]="groupCoverage.get(c.countryId) === 'exc' && !c.excluded" (click)="setCountry(c, 'exc')">Exclude</button>
          </div>
        </div>
      } @empty {
        <div class="cc-empty">No countries match "{{ query }}".</div>
      }
    </div>
  }

  <!-- COUNTRY GROUPS -->
  @if (activeTab == 'groups') {
    <div class="grid-list">
      @for (g of filteredGroups; track g.groupId) {
        <div class="group-block">
          <div class="grid-row" [class.row-inc]="g.included" [class.row-exc]="g.excluded">
            <button type="button" class="expand-btn" [class.open]="expandedGroups.has(g.groupId)" (click)="toggleExpand(g.groupId)" aria-label="Show countries">&rsaquo;</button>
            <div class="row-icon">🗂️</div>
            <div class="row-main">
              <div class="row-name">{{ g.groupName }}</div>
              <div class="row-meta">{{ (g.countryIds || []).length }} countries &middot; {{ g.allCustomers ? 'Shared by SureSim' : 'Your group' }}</div>
            </div>
            <div class="seg">
              <button type="button" class="seg-btn" [class.on-inc]="g.included" (click)="setGroup(g, 'inc')">Include</button>
              <button type="button" class="seg-btn" [class.on-exc]="g.excluded" (click)="setGroup(g, 'exc')">Exclude</button>
            </div>
          </div>
          @if (expandedGroups.has(g.groupId)) {
            <div class="group-countries">
              @for (gc of getGroupCountries(g); track gc.countryId) {
                <div class="group-country">
                  <span class="gc-name">{{ gc.countryName || gc.alias }}</span>
                  <span class="gc-code">{{ gc.alpha2Code }}</span>
                </div>
              } @empty {
                <div class="gc-empty">No countries in this group.</div>
              }
            </div>
          }
        </div>
      } @empty {
        <div class="cc-empty">No country groups match "{{ query }}".</div>
      }
    </div>
  }

  <div class="cc-hint">
    Including or excluding a <strong>group</strong> applies to every country in it. When a country is covered by both an
    include and an exclude, <strong>exclude always wins</strong>. Manage the groups under <strong>Config &rsaquo; Country Groups</strong>.
  </div>
</div>
